import Axios from 'axios';
import { uniq } from 'lodash';
import errorReporter from '@app/errorReporter';
import {
  buildPusherChannel,
  HEARTBEAT_PREFIX,
  APPOINTMENT_PREFIX,
} from 'utils';

angular.module('bb.appointments').factory('ApptWatchService', ApptWatchService);

ApptWatchService.$inject = ['$rootScope'];
// A service to provide updates on which admin is watching an appointment
// Currently allows a single appointment to be watched per tab
function ApptWatchService($rootScope) {
  const { auth, pusher } = $rootScope;
  if (!auth.org.features.includes('APPOINTMENT')) {
    return {};
  }

  // return values
  const vm = this;
  vm.state = {};
  vm.subscribeAppt = subscribeAppt;
  vm.unsubscribeAppt = unsubscribeAppt;
  vm.appointmentId = null;
  vm.appointmentChannelName = null;
  vm.connecting = false;

  function subscribeOrg() {
    if (!vm.connecting) {
      vm.connecting = true;

      const channelName = buildPusherChannel(HEARTBEAT_PREFIX, auth.org.id);
      const heartbeatChannel = pusher.subscribe(channelName);

      heartbeatChannel.bind('viewing_appointment_added', data => {
        Object.entries(data).forEach(([appointmentId, userIds]) => {
          vm.state[appointmentId] = vm.state[appointmentId]
            ? uniq([...vm.state[appointmentId], ...userIds])
            : userIds;
        });
        $rootScope.$apply();
        $rootScope.$broadcast('viewing_appointment_changed', vm.state);
      });

      heartbeatChannel.bind('viewing_appointment_removed', data => {
        Object.entries(data).forEach(([appointmentId, userIds]) => {
          if (vm.state[appointmentId]) {
            vm.state[appointmentId] = vm.state[appointmentId].filter(
              userId => !userIds.includes(userId),
            );
            if (!vm.state[appointmentId].length) {
              delete vm.state[appointmentId];
            }
          }
        });
        $rootScope.$apply();
        $rootScope.$broadcast('viewing_appointment_changed', vm.state);
      });

      heartbeatChannel.bind('appointment_status', args => {
        $rootScope.$broadcast('appointment_status', args);
      });

      heartbeatChannel.bind('appointment_flagged', args => {
        $rootScope.$broadcast('appointment_flagged', args);
      });

      heartbeatChannel.bind('appointment_urgency_updates', args => {
        $rootScope.$broadcast('appointment_urgency_updates', args);
      });

      heartbeatChannel.bind('answering_settings_toggled', () => {
        $rootScope.$broadcast('answering_settings_toggled');
      });

      heartbeatChannel.bind('appointment_covid19_signed', args => {
        $rootScope.$broadcast('appointment_covid19_signed', args);
      });

      heartbeatChannel.bind('pusher:subscription_error', err => {
        errorReporter.error(new Error(err.error));
      });

      Axios.get('/appointment/heartbeat/subscribe')
        .then(res => {
          if (res.status === 403) {
            window.localStorage.setItem('loggedOut', true);
          } else if (res.status === 200) {
            vm.state = res.data;
            $rootScope.$apply();
          }
        })
        .catch(errorReporter.error)
        .finally(() => {
          vm.connecting = false;
        });
    }
  }

  function subscribeAppt(id) {
    if (!id) {
      return errorReporter.error('You must provide a ID to subscribe to');
    }

    vm.appointmentChannelName = buildPusherChannel(APPOINTMENT_PREFIX, id);
    pusher.subscribe(vm.appointmentChannelName);
  }

  function unsubscribeAppt() {
    vm.appointmentId = null;
    pusher.unsubscribe(vm.appointmentChannelName);
    vm.appointmentChannelName = null;
  }

  // subscribe to the org initally
  if (pusher.connection.state === 'connected') {
    subscribeOrg();
  }
  // only on reconnection
  pusher.connection.bind('connected', () => {
    subscribeOrg();
    if (vm.appointmentId) subscribeAppt(vm.appointmentId);
    $rootScope.$apply();
  });

  return vm;
}
